import { Bar } from "react-chartjs-2";

function BarPlot(
  data,
  leftAxisTitle,
  leftAxisUnit,
  rightAxisTitle,
  rightAxisUnit,
  legendTitle
) {
  const config = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: 'index',
      intersect: false,
    },
    scales: {
      x: {
        stacked: true,
        ticks: {
          autoSkip: true,
          maxTicksLimit: 10,
          font: {
            size: 11,
          },
        },
        grid: {
          display: false,
          drawBorder: false,
        },
      },
      y: {
        beginAtZero: true,
        position: 'left',
        stacked: true,
        id: 'y',
        title: {
          display: true,
          text: leftAxisUnit ? `${leftAxisTitle} (${leftAxisUnit})` : leftAxisTitle,
          font: {
            size: 16,
            weight: 'bold',
          },
        },
        ticks: {
          font: {
            size: 11,
          },
        },
        grid: {
          color: 'rgba(0, 0, 0, 0.08)',
        },
      },
      y1: {
        beginAtZero: true,
        minBarLenght: 5,
        position: 'right',
        stacked: true,
        id: 'y1',
        title: {
          display: true,
          text: rightAxisUnit ? `${rightAxisTitle} (${rightAxisUnit})` : rightAxisTitle,
          font: {
            size: 16,
            weight: 'bold',
          },
        },
        ticks: {
          font: {
            size: 11,
          },
        },
        grid: {
          drawOnChartArea: false,
        },
      }
    },
    elements: {
      bar: {
        borderRadius: 6,
        borderSkipped: false,
      },
      line: {
        borderWidth: 2,
      },
      point: {
        radius: 2,
        hoverRadius: 3,
      }
    },
    layout: {
      padding: {
        right: 10,
        top: 10,
        left: 10,
        bottom: 10
      },
    },
    plugins: {
      legend: {
        position: 'top',
        title: {
          display: true,
          text: legendTitle,
          font: {
            size: 14,
            weight: 'bold',
          }
        },
        labels: {
          boxWidth: 12,
          boxHeight: 12,
          usePointStyle: true,
          font: {
            size: 11,
          },
        },
      },
      datalabels: {
        display: false
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        callbacks: {
          label: (context) => {
            const label = context.dataset.label || '';
            const value = context.parsed?.y;
            if (value === null || value === undefined) {
              return `${label}: N/A`;
            }
            return `${label}: ${value}`;
          },
        },
      }
    }
  };

  return (
    <div style={{
      border: '1px solid #e0e0e0',
      borderRadius: '8px',
      backgroundColor: '#fff',
      padding: '12px',
      boxShadow: '0 8px 18px rgba(0, 0, 0, 0.06)',
    }}>
      {data ? (
        <div style={{ height: '320px' }}>
          <Bar
            key={'bar_chart'}
            options={config}
            data={data}
          />
        </div>
      ) : (
        <div style={{
          height: '320px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#666'
        }}>
          Loading...
        </div>
      )}
    </div>
  )
};

export default BarPlot;
